import { Navigate } from 'react-router-dom';

import { useHasShopifyData } from '@/features/shopify/hooks/use-has-shopify-data';
import { CUSTOMER_HOME_PATH } from '@/lib/navigation/constants/post-auth-destination-constants';

interface ShopifyRouteGuardProps {
  children: React.ReactNode;
}

export function ShopifyRouteGuard({ children }: ShopifyRouteGuardProps) {
  const { hasShopifyData, isLoading } = useHasShopifyData();

  if (isLoading) {
    return null;
  }

  if (!hasShopifyData) {
    return <Navigate replace to={CUSTOMER_HOME_PATH} />;
  }

  return <>{children}</>;
}
